<template>
  <div class="app-wrapper">
    <div class="main-container">
      <app-main />
    </div>
  </div>
</template>

<script>
import { AppMain } from './components'
export default {
  components: {
    AppMain
  },
  props: {},
  data () {
    return {
      setColors: [
        {
          title: '角度测量',
          type: 'Angle',
          val: '#ff7e00',
          bgColor: '',
          src: 'Angle.png'
        },
        {
          title: '直尺测量',
          type: 'Length',
          val: '#ff7e00',
          bgColor: '',
          src: 'CenterLine.png'
        },
        {
          title: '圆形测量',
          type: 'EllipticalRoi',
          val: '#ff7e00',
          bgColor: '',
          src: 'ellipse.png'
        },
        {
          title: '矩形测量',
          type: 'RectangleRoi',
          val: '#ff7e00',
          bgColor: '',
          src: 'rectangle.png'
        },
        {
          title: '点测量',
          type: 'Probe',
          val: '#ff7e00',
          bgColor: '',
          src: 'probe.png'
        },
         {
          title: '范围测量',
          type: 'FreehandRoi',
          val: '#ff7e00',
          bgColor: '',
          src: 'areehandRoi.png'
        },
        {
          title: '箭头标注',
          type: 'ArrowAnnotate',
          val: '#ff7e00',
          bgColor: '',
          src: 'arrowAnnotate.png'
        },

          {
          title: '文本标注',
          type: 'TextMarker',
          val: '#ff7e00',
          bgColor: '',
          src: 'textMarker.png'
        },
        {
          title: '线段标注',
          type: 'LineMarkerTool',
          val: '#ff7e00',
          bgColor: '',
          src: 'lineMarker.png'
        },


      ]
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {
    // document.addEventListener('gesturestart',function(event){
    //   // alert(1)
    //   event.preventDefault()
    // })
    window.localStorage.setItem('setColors', JSON.stringify(this.setColors))
  }
}
</script>
<style lang="scss" scoped>
.app-wrapper,
.main-container {
  width: 100%;
  height: 100%;
}
</style>
